"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnClickEvent = exports.loadingEvents = void 0;
var AddBackorderDemandEvent = _interopRequireWildcard(require("@ori-events/add-backorder-demand"));
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var ReplaceShoppingBagItem = _interopRequireWildcard(require("@ori-events/replace-shopping-bag-item"));
var ReplaceSubscriptionEvent = _interopRequireWildcard(require("@ori-events/replace-subscription"));
var _react = require("react");
var _constants = require("../../constants");
var _internal = require("../../hooks/internal");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const loadingEvents = exports.loadingEvents = [AddBackorderDemandEvent.Name, ReplaceShoppingBagItem.Name, ReplaceSubscriptionEvent.Name];
const useOnClickEvent = () => {
  const {
    currentProduct: {
      name
    },
    currentShade: {
      price: {
        current
      },
      productCode
    }
  } = (0, _internal.useProduct)();
  const {
    lineNumber,
    placement
  } = (0, _internal.useAnalyticsData)();
  const {
    droppingId,
    subscriptionId
  } = (0, _internal.useReplaceSubscriptionData)();
  const {
    originalItemCode
  } = (0, _internal.useSharedConfiguration)();
  // istanbul ignore next @preserve -- No need to test fallback
  const formattedPrice = current ?? undefined;
  const replacementType = originalItemCode ? _constants.MANUAL_REPLACEMENT : undefined;
  return (0, _react.useCallback)(quantity => {
    if (droppingId !== undefined && subscriptionId !== undefined) {
      return new CustomEvent(ReplaceSubscriptionEvent.Name, {
        detail: {
          droppingId,
          itemCode: productCode,
          subscriptionId
        }
      });
    }
    // In this case Checkout just replaces the item on specified line number with the new one, quantity is not relevant
    if (originalItemCode && lineNumber != null) {
      return new CustomEvent(ReplaceShoppingBagItem.Name, {
        detail: {
          itemCode: productCode,
          lineNumber
        }
      });
    }
    if (lineNumber != null) {
      return new CustomEvent(AddBackorderDemandEvent.Name, {
        detail: {
          formattedPrice,
          itemCode: productCode,
          lineNumber,
          localName: name,
          placement,
          quantity
        }
      });
    }
    return new CustomEvent(AddToBasketEvent.Name, {
      detail: {
        formattedPrice,
        itemCode: productCode,
        localName: name,
        originalItemCode,
        placement,
        quantity,
        replacementType
      }
    });
  }, [droppingId, formattedPrice, lineNumber, name, originalItemCode, placement, productCode, replacementType, subscriptionId]);
};
exports.useOnClickEvent = useOnClickEvent;
